import { z } from "zod";

/**
 * Schema for a single component in Content Optimization.
 */
export const visibleComponentSchema = z.object({
  name: z.string(),
  values: z.array(z.string()),
});

/**
 * Inferred type for a single visible component.
 */
export type VisibleComponent = z.infer<typeof visibleComponentSchema>;

/**
 * Schema for component_store used in Content Optimization steps.
 * Contains component name to variant values mapping.
 *
 * The actual data uses `visible_components` array format.
 */
export const componentStoreSchema = z.object({
  visible_components: z.array(visibleComponentSchema).optional(),
  deactivated_values: z.record(z.string(), z.array(z.string())).optional(),
  alt_values: z.record(z.string(), z.array(z.string())).optional(),
  new_values: z.record(z.string(), z.array(z.string())).optional(),
});

/**
 * Inferred type for component_store.
 * Schema format: `{visible_components: [{name, values}, ...]}`
 */
export type ComponentStore = z.infer<typeof componentStoreSchema>;
